export default {
  MESSAGE_ERROR: 'MESSAGE_ERROR',
  MESSAGE_WARNING: 'MESSAGE_WARNING',
  MESSAGE_INFO: 'MESSAGE_INFO',
  MESSAGE_SUCCESS: 'MESSAGE_SUCCESS',
  MESSAGE_API_ERRORS: 'MESSAGE_API_ERRORS',

  USER_SET: 'USER_SET',
};
